import React, { Component } from "react";
import isEmpty from "validator/lib/isEmpty";
import isNumeric from "validator/lib/isNumeric";
import InlineError from "../messages/InlineError";
import { Form, Button, Message, Icon } from "semantic-ui-react";
//import ReCAPTCHA from "react-google-recaptcha";
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';

class SignupForm extends Component {
  state = {
    data: { userID: "" },
    recaptchaValue: "",

    isLoading: false,
    errors: {},
  };

  validate = (data) => {
    const errors = {};
    if (isEmpty(data.userID)) errors.userID = "No puede estar en blanco.";
    if (!isNumeric(data.userID))
      errors.userID = "Este campo debe contener números exlusivamente.";
    if (isEmpty(data.recaptchaValue))
      errors.recaptchaValue = "Debe marcar la casilla de verificación.";
    return errors;
  };
  onChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });

  onReCaptchaClick = (value) => {
    this.setState({ recaptchaValue: value });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate({
      ...this.state.data,
      recaptchaValue: this.state.recaptchaValue,
    });
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.props
        .submit({
          ...this.state.data,
          recaptchaValue: this.state.recaptchaValue,
        })
        .catch((err) => {
          // console.log(err.response);
          return this.setState({
            errors: err.response.data.errors,
            loading: false,
          });
        });
    }
  };

  render() {
    const { errors } = this.state;

    return (
      <Form onSubmit={this.onSubmit}>
        {errors.global && (
          <Message icon negative>
            <Icon name="lock" />
            <Message.Content>
              <Message.Header>{errors.global}</Message.Header>
            </Message.Content>
          </Message>
        )}

        <Form.Field>
          <label htmlFor="userID">Identificación</label>
          <input
            className="u-full-width"
            type="text"
            placeholder="Escriba su identificación"
            id="userID"
            name="userID"
            onChange={this.onChange}
          />
          {errors.userID && <InlineError text={errors.userID} />}
        </Form.Field>
        <Form.Field>
          <div className="form_group_recaptcha">
            {/*<ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_APIKEY}
              onChange={this.onReCaptchaClick}
              hl="es-419"
            />*/}
            <GoogleReCaptcha onVerify={this.onReCaptchaClick} />
            {errors.recaptchaValue && (
              <InlineError text={errors.recaptchaValue} />
            )}
          </div>
        </Form.Field>
        <Button
          color="blue"
          content="Iniciar"
          icon="sign in"
          labelPosition="left"
        />
      </Form>
    );
  }
}

export default SignupForm;
